// Axios
import { internalAxiosInstance } from '@nephro/core/axios/internal-axios-instance';
import { externalAxiosInstance } from '@nephro/core/axios/external-axios-instance';

// Connector
import tokenInterceptor from 'core/axios/interceptors/tokenInterceptor';
import { connectorError } from './connector-error';

export class Connector {
  constructor(http) {
    this.http = http;
  }

  async get(url, config = {}) {
    const baseConfig = await tokenInterceptor();
    return new Promise((resolve, reject) => {
      this.http
        .get(url, { ...config, ...baseConfig })
        .then((response) => resolve(response))
        .catch((error) => reject(connectorError(error)));
    });
  }

  async post(url, body = {}, config = {}) {
    const baseConfig = await tokenInterceptor();
    return new Promise((resolve, reject) => {
      this.http
        .post(url, body, { ...config, ...baseConfig })
        .then((response) => resolve(response))
        .catch((error) => reject(connectorError(error)));
    });
  }

  async update(url, body = {}, config = {}, method = 'patch') {
    const baseConfig = await tokenInterceptor();
    return new Promise((resolve, reject) => {
      this.http[method](url, body, { ...config, ...baseConfig })
        .then((response) => resolve(response))
        .catch((error) => reject(connectorError(error)));
    });
  }

  async delete(url, config = {}) {
    const baseConfig = await tokenInterceptor();
    return new Promise((resolve, reject) => {
      this.http
        .delete(url, { ...config, ...baseConfig })
        .then((response) => resolve(response))
        .catch((error) => reject(connectorError(error)));
    });
  }
}

export default new Connector(internalAxiosInstance);
export const externalConnector = new Connector(externalAxiosInstance);
